<template>
  <div>
    <v-dialog
      v-model="getModalCadastroAtividadeOs"
      persistent
      max-width="720px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Registrar de atividade</v-card-title>
        <v-card-text>
          <v-form class="px-3" ref="formAtividadeOs">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadeOs.data_inicio"
                  label="Data de Início"
                  outlined
                  dense
                  type="date"
                  class="ml-1 mr-1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadeOs.horario_inicio"
                  label="Hrário de Início"
                  outlined
                  dense
                  type="time"
                  class="ml-1 mr-1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadeOs.data_termino"
                  label="Data de Conclusão"
                  outlined
                  dense
                  type="date"
                  class="ml-1 mr-1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="getAtividadeOs.horario_termino"
                  label="Horário de Conclusão"
                  outlined
                  dense
                  type="time"
                  class="ml-1 mr-1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  :items="getFuncionarios"
                  v-model="getAtividadeOs.tecnico_id"
                  item-value="id"
                  item-text="nome_abreviado"
                  label="Técnico"
                  outlined
                  dense
                  class="ml-1 mr-1"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md12>
                <v-textarea
                  v-model="getAtividadeOs.descricao"
                  label="Descrição"
                  outlined
                  dense
                  class="ml-1 mr-1"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 md12>
                <v-checkbox
                  v-model="getAtividadeOs.concluida"
                  label="Concluída"
                  class="ml-1 mr-1"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            dense
            @click="setModalCadastroAtividadeOs(false)"
            >Voltar</v-btn
          >
          <v-btn color="error" @click="setModalExcluirAtividadeOs(true)" outlined>Excluir</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined dense @click="salvar()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalExcluir />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalExcluir from "@/pages/ordemServico/atividade/ModalExcluir";
export default {
  components: {
    ModalExcluir,
  },
  computed: {
    ...mapGetters([
      "getModalCadastroAtividadeOs",
      "getFuncionarios",
      "getAtividadeOs",
      "getOrdemServico",
    ]),
  },
  methods: {
    ...mapActions([
      "setModalCadastroAtividadeOs",
      "salvarAtividadeOs",
      "atualizarAtividadeOs",
      "setModalExcluirAtividadeOs",
    ]),
    salvar() {
      if (this.$refs.formAtividadeOs.validate() == false) {
        return;
      }

      if (this.getAtividadeOs.id) {
        this.atualizarAtividadeOs(this.getAtividadeOs);
      } else {
        this.getAtividadeOs.ordem_servico_id = this.getOrdemServico.id;
        this.salvarAtividadeOs(this.getAtividadeOs);
      }
    },
  }
};
</script>